import React, { useRef, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Button, Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../../Componentes/Basicos/LVGridCabecera";
import { PaginaReporte } from "../../../Componentes/Compuestos/Paginas/PaginaReporte";
import COM_DocsCompra_Detalle from "../COM_DocsCompra_Detalle";
import { function_COM_DocsCompra_Cabecera_ListarPorPagar, function_COM_DocsCompra_Cabecera_ReporteDocCompra, function_COM_DocsCompra_Cabecera_ReporteDocCompra_EnvioMail } from "neftis7_apicaller/src/funciones/COM/DocsCompra/COM_DocsCompra_Cabecera";
import { function_ABM_EEX_Proveedores_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Proveedores";
import { ObtieneParametros, TratamientoDeVariableBoolean } from "neftis7_apicaller/src/funciones/Varios";

export const COM_Reporte_DocsCompra_PendientesDePago = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState([])
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState([])
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState([])
  const [FechaDesde, setFechaDesde] = useState(new Date().setDate(new Date().getDate() - 3650));
  const [FechaHasta, setFechaHasta] = useState(new Date().setDate(new Date().getDate() + 3650));

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const handleOnClickPrint = async (item) => {
    try {
      setLoading(true);
      const formato = "pdf"
      const reportData = await function_COM_DocsCompra_Cabecera_ReporteDocCompra(item.IdDocCompra, formato);

      if (formato === 'pdf') {
        const file = new Blob([reportData], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `DocCompra${item.IdDocCompra}.pdf`; // Nombre del archivo con extensión
        link.click();
      } else if (formato === 'html') {
        const htmlContent = reportData.data;
        const newWindow = window.open();
        newWindow.document.write(htmlContent); // Mostrar HTML en nueva ventana
        newWindow.document.close();
      }

    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  const handleOnClickEnviarEMail = async (item) => {
    try {
      setLoading(true);

      const idProveedor = item.IdProveedor;

      if (!idProveedor) {
        alert("No se encontró un proveedor asociado al Documento de Compra.");
        return;
      }

      // Llamar a la función para obtener la dirección de correo del proveedor
      const resultProveedor = await function_ABM_EEX_Proveedores_Leer(idProveedor);
      const correoElectronico = resultProveedor?.data.Emails?.replace(" ", "; ") || "";

      // Mostrar popup para confirmar o editar el correo
      const nuevoCorreo = window.prompt(
        "Se enviará el E-Mail a la siguiente dirección o ingrese una nueva:",
        correoElectronico
      );

      if (!nuevoCorreo) {
        alert("El envío ha sido cancelado.");
        return;
      }

      const formato = "pdf"
      const reportData = await function_COM_DocsCompra_Cabecera_ReporteDocCompra_EnvioMail(item.IdDocCompra, nuevoCorreo);

      alert("Se ha enviado el E-Mail")
    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos    
    setLoading(true)
    try {
      const resultData = await function_COM_DocsCompra_Cabecera_ListarPorPagar(FechaDesde, FechaHasta);

      const dataOrdenada = resultData.data.sort((a, b) => new Date(b.FechaVencimiento) - new Date(a.FechaVencimiento));

      setData(dataOrdenada);

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  const getDataParametros = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      setGlobalUsaArticulosConPresentacion(globalUsaArticulosConPresentacionLocal)
      setGlobalUsaArticulosConTamano(globalUsaArticulosConTamanoLocal)
      setGlobalUsaArticulosConUnidadDeMedida(globalUsaArticulosConUnidadDeMedidaLocal)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }

    getDataParametros();
    getData()
  }, []);

  return (
    <PaginaReporte
      Titulo="DOCUMENTOS DE COMPRA  A  PAGAR"
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="IdDocCompra"
            urlEdicion="/COM_DocsCompra_ModificacionCreacion"
            onClickPrint={handleOnClickPrint}
            onClickEnviarEmail={handleOnClickEnviarEMail}
          >
            <Summary>
              <TotalItem
                column="IdDocCompra"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              <TotalItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />

              <GroupItem
                column="IdDocCompra"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number"
                showInGroupFooter={true} />
            </Summary>

            <Column caption="Código" dataField="IdDocCompra" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Vencimiento" dataField="FechaVencimiento" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Número" dataField="Factura" width="150" alignment="Left" dataType="string" />
            <Column caption="Razón Social" dataField="ABM_EEX_Proveedores_RazonSocial" width="100%" minWidth={100} alignment="Left" dataType="string" />
            <Column caption="Tipo" dataField="COM_DocsCompra_Tipos_Descripcion" width="130" alignment="Left" dataType="string" />
            <Column caption="Estado" dataField="TODOS_Estados_Descripcion" width="100" alignment="Left" dataType="string" />

            <Column caption="Importes" alignment="Center">
              <Column caption="Moneda" dataField="ABM_CON_Monedas_Descripcion" width="70" alignment="Left" dataType="string" visible={false} />
              <Column caption="Cotización" dataField="Cotizacion" width="70" alignment="Right" dataType="number" format="currency" visible={false} />

              <Column caption="Neto" dataField="ImporteNeto" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="I.V.A." dataField="ImporteIVA" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="Total" dataField="ImporteTotal" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="Total P.I." dataField="ImporteTotalPostImpuestos" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="Pagado" dataField="ImportePago" width="150" alignment="Right" dataType="number" format="currency" />
            </Column>

            <Column caption="Creador" dataField="I_UsuarioCreador" width="130" alignment="Left" dataType="string" />
            <Column caption="Planta" dataField="CodigoPlanta" width="80" alignment="Left" dataType="string" visible={false} />
            <Column caption="Term." dataField="Terminal" width="80" alignment="Right" dataType="number" />

            <Column caption="Concepto" dataField="Concepto" width="100" alignment="Left" dataType="string" visible={false} />
            <Column caption="Observaciones" dataField="Observaciones" width="100" alignment="Left" dataType="string" visible={false} />

            <MasterDetail
              enabled={true}
              component={COM_DocsCompra_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaReporte>
  );
};
